import { Badge } from '@toggle/design-system';
import styled from 'styled-components';

import { HeaderNavigation } from './header-navigation/HeaderNavigation';

export const StyledHeaderNavigation = styled(HeaderNavigation)`
  z-index: var(--z-index-sidebar);
`;

const SHADOW_COLOR = '#6592fd';

export const StyledCounterBadge = styled(Badge)<{ $withError: boolean }>`
  position: relative;
  z-index: 1;
  ${Badge.Styled.BadgeNumerical} {
    background-color: ${SHADOW_COLOR};
    box-shadow: ${({ $withError }) =>
      $withError ? 'none' : `0px 0px 5px 1px ${SHADOW_COLOR}`};
  }
`;

export const StyledErrorBadge = styled(Badge)<{ $withCounterBadge: boolean }>`
  position: absolute;
  right: ${({ $withCounterBadge }) => ($withCounterBadge ? '11px' : '0px')};
  ${Badge.Styled.BadgeNumerical} {
    background-color: var(--icon-critical);
  }
`;
